import axios from 'axios';
import { find } from 'lodash';

export default {
    namespaced: true,
    state: {
        all: [],
    },
    getters: {
        getAll(state) {
            return state.all;
        },
        getByFlangeSizeAndPumpGroup: (state) => (flangeSize, pumpGroupId) => {
            return find(state.all, elasticCoupling => {
                const flangeSizeMatches = elasticCoupling.flange_size === flangeSize;
                const pumpGroupMatches = elasticCoupling.pump_group_id === pumpGroupId;

                return flangeSizeMatches && pumpGroupMatches;
            });
        },
    },
    actions: {
        index({commit}) {
            return axios.get(process.env.VUE_APP_API_URL + 'elastic_couplings')
                .then(({data}) => {
                    commit('setElasticCouplings', data);
                });
        },
    },
    mutations: {
        setElasticCouplings(state, couplings) {
            state.all = couplings;
        },
    },
};
